/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { ApolloError } from "@apollo/client";
import { ERROR_TEXT } from "~/constants";

export const trimTransform = {
  input: (value: string | undefined) => value?.trim() ?? "",
  output: (event: React.ChangeEvent<HTMLInputElement>) =>
    event.target.value?.trim(),
};

export function getCustomerError(error?: ApolloError) {
  if (hasErrorCode(error, "ErrUnableToAssumeCredentials")) {
    return "Unable to assume credentials. They can be expired or invalid.";
  }

  if (hasErrorCode(error, "ErrCredentialsValidation")) {
    return "Credential validation failed.";
  }

  return ERROR_TEXT.failedAddingAccount;
}

function hasErrorCode(error: ApolloError | undefined, code: string) {
  return error?.graphQLErrors.some(
    (graphqlError) => graphqlError.extensions.code === code
  );
}
